$(document).ready(function () {
    'use strict';

    if ($('.js_sellYourVehicleEnquiryForm').length) {
        submitForm('.js_sellYourVehicleEnquiryForm');
    }
});